import { Injectable } from '@angular/core';
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams,
  ResponseContentType
} from "@angular/http";
@Injectable()
export class InToolsService {

  constructor(private auth: AuthenticationService, private http: Http) { }
  //--------------Promotion-----------------//
  getPromotion(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Promotion",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  get_PromotionBulk(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PromotionBulk",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  save_Promotions(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Promotions",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Validate_ItemsOnSave(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Validate_ItemsOnSave",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ReportMenuForPromotionImage() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_ReportMenuForPromotionImage",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Delete_Promotion(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_Promotion",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Promotion-----------------//
  // ------------------Customer Service -------------------------
  getCustomerServiceVoucherNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ServiceId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveCustomerService(FilterItems: any) {
    if (FilterItems.ServiceId == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Service",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Service",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getService(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Service",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getServiceById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ServiceById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  completeService(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_Service",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -------------------Customer Service---------------------------
  // -------------------selling Price Level---------------------------
  Save_SellingPriceLevel(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SellingPriceLevel",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_SellingPriceLevel(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SellingPriceLevel",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSellingPriceLevelById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetSellingPriceLevelById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SellingPriceLevelList(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SellingPriceLevelList",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_SellingPriceLevel(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_SellingPriceLevel",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -------------------selling Price Level---------------------------
  // -------------------selling Price Relation---------------------------
  Save_SellingPriceBranch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SellingPriceBranch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_SellingPriceBranch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SellingPriceBranch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSellingPriceBranchById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetSellingPriceBranchById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SellingPriceBranchList(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SellingPriceBranchList",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_SellingPriceBranch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_SellingPriceBranch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSellingPriceBranchByBranchId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetSellingPriceBranchByBranchId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -------------------selling Price Relation---------------------------
  // -------------------Prica Updation-----------------------------------
  Get_ItemForPriceUpdation(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ItemForPriceUpdation",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_PriceChangeLog(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_PriceChangeLog",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_PriceChangeLog(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_PriceChangeLog",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -------------------Prica Updation-----------------------------------
  // -------------------Item Category edit-----------------------------------
  Get_ItemByFilter(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ItemByFilter",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_ItemCategory(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_ItemCategory",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -------------------Item category edit-----------------------------------
  //--------------------Excel Validation--------------------------------
  Validate_Excel(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Validate_Excel",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------------Excel Validation-------------------------------
  //--------------------Price Change-------------------------------
  Get_ItemForPriceChange(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ItemForPriceChange",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_ItemPrice(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_ItemPrice",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------------Price Change-------------------------------
  //--------------------Approval List------------------------------
  Get_PendingListForApproval(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PendingListForApproval",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_ApprovalDetailStatus(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_ApprovalDetailStatus",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ApprovalRulesByType(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ApprovalRulesByType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_ApprovalDetail(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ApprovalDetail",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_ApprovalDetail(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_ApprovalDetail",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ApprovedList(model: any){
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ApprovedList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_ApprovedDetailStatus(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_ApprovedDetailStatus",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_TransactionApprovalDetail(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_TransactionApprovalDetail",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------------Approval List------------------------------
  //--------------------Style Code---------------------------------
  Get_ItemForStyleCode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ItemForStyleCode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Export_ItemFromStyleCode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Export_ItemFromStyleCode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_DataForExportStyleCode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DataForExportStyleCode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Download_StyleCode(model: any) {
    var httpo = { resposeType: 'blog' as 'json' }
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Download_StyleCode", model,
      {
        responseType: ResponseContentType.Blob
      })
  }

  Get_StyleCodeImportData(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_StyleCodeImportData",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------------Style Code---------------------------------
  //--------------------Supplier Control---------------------------

  Get_SupplierContolForUpdate(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SupplierContolForUpdate",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_SupplierControl(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SupplierControl",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------------Supplier Control---------------------------
  //--------------------Counter Items------------------------------
  Get_CounterItems() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_CounterItems",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_CounterItems(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_CounterItems",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Delete_CounterItems(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_CounterItems",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------------Counter Items------------------------------
  //--------------------Item Control------------------------------
  Get_ItemcontrolList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ItemcontrolList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_ItemControl(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_ItemControl",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------------Item Control------------------------------
  //--------------------Weighing Scale Items------------------------------
  Get_WeighingScaleItems(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_WeighingScaleItems",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Post_WeighingScaleItems(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Post_WeighingScaleItems",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Export_WeighingScale_Text(model: any){
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Export_WeighingScale_Text",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------------Weighing Scale Items------------------------------
 //--------------------Serial Number Tracking------------------------------
 Get_SerialNumberByBarcode(model:any){
  return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SerialNumberByBarcode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
 }
 //--------------------Serial Number Tracking------------------------------
 
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/in-tools.service.ts